import React from 'react';

interface ITabSettings {
    tabs: any;
    activeTab: any;
    onClickTab: (tab: any) => void;
}

const TabSettings = ({
    tabs,
    activeTab,
    onClickTab
}: ITabSettings) => {

    return (
        <div className='flex flex-row items-center mb-4'>
            {tabs?.map((item: any, idx: number) => {
                return (
                    <div key={idx} className={`mr-2 px-1 py-2 ${activeTab?.value === item?.value ? 'text-black dark:text-primary-dark border-b border-b-1 border-b-black dark:border-borderColor-darkMode bg-[#FDFDFD] dark:bg-[#2f2f2f]' : 'text-primary-light'} `}>
                        <p>{item?.name}</p>
                    </div>
                )
            })}
        </div>
    )
}

export default TabSettings;